import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { useGET_rtiRiskCriteriaOneListQuery } from 'redux/api/rtiApi'
import { IStudent } from "types"
import MainTable from "components/organisms/tables/MainTable"
import { useTableModel } from 'utils/tableModels/useRtiRiskCriteriaOneTableModel'
import { Button, Tooltip } from '@mui/material'
import { Add } from '@mui/icons-material'
import { useTranslation } from "react-i18next"

interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const RtiRiskCriteriaList: FC<IProps> = ({ student }) => {
    
    const { t } = useTranslation()
    const navigate  =  useNavigate()

    const filters = {
        student: student.student_profile_id
    }

    return <> 
       <MainTable
            useTableModel={useTableModel}
            getTableData={ useGET_rtiRiskCriteriaOneListQuery}
            tableRowParams={ {'sid': student.id} }
            filters={filters}
            header={<div style={{ textAlign: 'right', paddingBottom: '10px' }}>

                  <Tooltip title={`${t('common.add-academic-risk-identification')}`} arrow placement='top'>
                    <Button
                        variant='contained'
                        color='success'
                        aria-haspopup='true'
                        onClick={() => navigate(`/rti-risks/add?student_id=${student.id}`)}
                        disableElevation
                        sx={{ 
                            lineHeight: '1rem'
                        }}
                    >
                        <Add />                         
                        <span>{`${t('common.add-academic-risk-identification')}`}</span>
                    </Button>
                </Tooltip>
                
            </div>}
       />    
    </>
}
export default RtiRiskCriteriaList